import React from 'react'
import {simpleFormat} from "lib/util";

// 段落文本
const Paragraph = (props) => {
  const Tag = props.displayTag || 'p'
  return (
    <div className={props.className}>
      {simpleFormat(props.content, Tag)}
    </div>
  )
}

export default Paragraph



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/rich_text/paragraph/index.js